<div class="dash" tabindex="-1">

  <!-- Ações flutuantes do modo CRUD (voltar / salvar) -->
  <nz-float-button *ngIf="insertAlterMode"
    class="dash__float dash__float--back"
    [nzIcon]="backIcon"
    nz-tooltip nzTooltipTitle="Voltar para grade"
    (nzOnClick)="voltar()">
  </nz-float-button>
  <ng-template #backIcon><span nz-icon nzType="rollback"></span></ng-template>

  <nz-float-button *ngIf="insertAlterMode && showSave"
    class="dash__float dash__float--save"
    nzType="primary"
    [nzIcon]="saveIcon"
    nz-tooltip nzTooltipTitle="Salvar dashboard"
    (nzOnClick)="salvar()">
  </nz-float-button>
  <ng-template #saveIcon><span nz-icon nzType="check"></span></ng-template>

  <!-- Dados principais (modo CRUD) -->
  <nz-collapse *ngIf="insertAlterMode" class="dash__main-data">
    <nz-collapse-panel [nzHeader]="mainDataHeader" [nzExtra]="mainDataExtra">
      <ng-template #mainDataHeader>Dados Principais</ng-template>
      <ng-template #mainDataExtra>
        <span class="dash__main-data-desc">
          Informar os Dados de Empresa e Contrato
          <span nz-icon nzType="setting"></span>
        </span>
      </ng-template>

      <div class="dash__company-contract" [formGroup]="formAction">
        <nz-form-item class="dash__field">
          <nz-form-label>Nome</nz-form-label>
          <nz-form-control>
            <input nz-input type="text" formControlName="NAME"
              nz-tooltip nzTooltipTitle="Nome do Dashboard">
          </nz-form-control>
        </nz-form-item>
        <search-input entityname="Mktpcontract" entitydesc="Contrato" [form]="formAction"
          controlname="CODECONTRACT" placeholder="Contrato" columnname="CODECONTRACT"
          class="no-padding-form-field" [loaddesc]="true" columndesc="Contrato"
          fieldname="CONTRACTNAME" (onchange)="onChangeCodeContract()">
        </search-input>
        <search-input entityname="Mktpcompanies" entitydesc="Empresa" [form]="formAction"
          controlname="CODECOMPANY" placeholder="Empresa" columnname="CODECOMPANY"
          class="no-padding-form-field" [loaddesc]="true" [condition]="conditionCodeCompany">
        </search-input>
      </div>
    </nz-collapse-panel>
  </nz-collapse>

  <!-- Abas do dashboard -->
  <div class="dash__tabs-wrapper">
    <nz-tabs class="dash__tabs"
      nzType="editable-card"
      [(nzSelectedIndex)]="selectedIndex"
      [nzHideAdd]="!(canEdit && insertAlterMode)"
      (nzAdd)="addNewTab()">

      <nz-tab *ngFor="let item of dashboard"
        [nzTitle]="tabTitleTpl"
        [nzClosable]="editMode(item.tabName)"
        (nzClose)="closeTab(item.tabName)">

        <ng-template #tabTitleTpl>
          <span class="dash__tab-title" *ngIf="!editMode(item.tabName)">{{ item.tabTitle }}</span>
          <input nz-input nzSize="small" class="dash__tab-title-input" type="text"
            *ngIf="editMode(item.tabName)"
            [(ngModel)]="item.tabTitle"
            (click)="$event.stopPropagation()">
        </ng-template>

        <div class="dash__tab-content">

          <!-- Quando há filtro: layout split -->
          <ng-container *ngIf="!showJSON(item.tabName) && item.filter != null && item.filter.length > 0; else semFiltro">
            <nz-layout class="filter-layout">
              <nz-sider
                class="filter-sider"
                nzTheme="light"
                [nzCollapsible]="false"
                [nzWidth]="400"
                [nzCollapsedWidth]="50"
                [nzCollapsed]="!state(item.tabName).isFilterExpanded">

                <div class="filter-panel" [class.filter-panel--collapsed]="!state(item.tabName).isFilterExpanded">
                  <div class="filter-panel__title-bar">
                    <button nz-button nzType="text" nzShape="circle"
                      (click)="toggleFilter(item.tabName)"
                      nz-tooltip
                      [nzTooltipTitle]="state(item.tabName).isFilterExpanded ? 'Recolher filtro' : 'Abrir filtro'">
                      <span nz-icon nzType="filter" class="filter-panel__icon"></span>
                    </button>
                    <span class="filter-panel__title" *ngIf="state(item.tabName).isFilterExpanded">Filtros</span>
                    <div class="filter-panel__collapse-btn" *ngIf="state(item.tabName).isFilterExpanded">
                      <button nz-button nzType="text" nzShape="circle" (click)="toggleFilter(item.tabName)">
                        <span nz-icon nzType="left"></span>
                      </button>
                    </div>
                  </div>

                  <nz-divider class="filter-panel__divider" *ngIf="state(item.tabName).isFilterExpanded"></nz-divider>

                  <div class="filter-panel__fields" [hidden]="!state(item.tabName).isFilterExpanded">
                    <prompt-filter-view
                      *ngIf="showFilter"
                      [expressao]="item.filter"
                      [showcard]="false"
                      [form]="state(item.tabName).filterForm"
                      [lastFilter]="state(item.tabName).lastFilter"
                      (apply)="notifyGadGets(item)">
                    </prompt-filter-view>
                  </div>

                  <div class="filter-panel__footer">
                    <button *ngIf="!state(item.tabName).isFilterExpanded"
                      nz-button nzType="text" nzShape="circle"
                      (click)="notifyGadGets(item)"
                      nz-tooltip nzTooltipTitle="Aplicar filtros">
                      <span nz-icon nzType="search"></span>
                    </button>

                    <button *ngIf="state(item.tabName).isFilterExpanded"
                      nz-button nzType="primary"
                      class="filter-panel__apply"
                      (click)="notifyGadGets(item)">
                      <span nz-icon nzType="search"></span> Aplicar
                    </button>
                  </div>
                </div>
              </nz-sider>

              <nz-content class="dashboard-content">
                <div class="dashboard-container">
                  <ng-container *ngTemplateOutlet="dashboardContent"></ng-container>
                </div>
              </nz-content>
            </nz-layout>
          </ng-container>

          <!-- Sem filtro ou modo JSON: dashboard direto -->
          <ng-template #semFiltro>
            <div class="dashboard-container">
              <ng-container *ngTemplateOutlet="dashboardContent"></ng-container>
            </div>
          </ng-template>

          <!-- Template compartilhado do conteúdo do dashboard -->
          <ng-template #dashboardContent>
            <div class="dash-toolbar" *ngIf="item.showToolbar || insertAlterMode">
              <h1 class="dash-toolbar__title" *ngIf="item.title && !editMode(item.tabName)">{{ item.title }}</h1>

              <nz-input-group *ngIf="editMode(item.tabName)" class="dash-toolbar__title-edit" [nzSuffix]="clearTitleTpl">
                <input nz-input type="text" placeholder="Informar o Título" [(ngModel)]="item.title">
              </nz-input-group>
              <ng-template #clearTitleTpl>
                <span nz-icon nzType="close-circle" nzTheme="fill" class="dash-toolbar__clear"
                  *ngIf="item.title" (click)="item.title = null"></span>
              </ng-template>

              <div class="dash-toolbar__spacer"></div>
              <a class="dash-toolbar__link" *ngIf="editMode(item.tabName) && !showJSON(item.tabName)"
                (click)="showJSONClick(item, true)">Modo Avançado</a>
              <a class="dash-toolbar__link" *ngIf="editMode(item.tabName) && showJSON(item.tabName)"
                (click)="showJSONClick(item, false)">Modo Desenho</a>
              <div class="dash-toolbar__spacer"></div>

              <!-- Leque de ações da aba -->
              <button nz-button nzShape="circle"
                class="dash-toolbar__fab dash-toolbar__fab--menu"
                *ngIf="!showJSON(item.tabName) && (canEdit || canInsert)"
                (click)="clickMenu(item.tabName)">
                <span nz-icon [nzType]="state(item.tabName).openMenu ? 'close' : 'menu'"></span>
              </button>

              <button nz-button nzShape="circle"
                class="dash-toolbar__fab dash-toolbar__fab--edit"
                [class.dash-toolbar__fab--confirm]="editMode(item.tabName)"
                [disabled]="!canEdit"
                *ngIf="state(item.tabName).openMenu && !showJSON(item.tabName)"
                nz-tooltip [nzTooltipTitle]="editMode(item.tabName) ? 'Concluir e salvar' : 'Editar layout'"
                (click)="actionEdit(item.tabName)">
                <span nz-icon [nzType]="editMode(item.tabName) ? 'check' : 'edit'"></span>
              </button>

              <button nz-button nzShape="circle"
                class="dash-toolbar__fab dash-toolbar__fab--filter"
                [disabled]="!canInsert"
                *ngIf="state(item.tabName).openMenu && !editMode(item.tabName) && !showJSON(item.tabName)"
                nz-tooltip nzTooltipTitle="Configurar filtros"
                (click)="openFilter(item)">
                <span nz-icon nzType="filter"></span>
              </button>

              <button nz-button nzShape="circle"
                class="dash-toolbar__fab dash-toolbar__fab--add"
                [disabled]="!canInsert"
                *ngIf="state(item.tabName).openMenu && !editMode(item.tabName) && !showJSON(item.tabName)"
                nz-dropdown [nzDropdownMenu]="gadgetMenu" nzTrigger="click"
                nz-tooltip nzTooltipTitle="Adicionar componente">
                <span nz-icon nzType="plus"></span>
              </button>

              <nz-dropdown-menu #gadgetMenu="nzDropdownMenu">
                <ul nz-menu>
                  <li nz-menu-item (click)="openCreator('minicard', item.tabName)">
                    <span nz-icon nzType="credit-card" class="dash-menu__icon dash-menu__icon--deep"></span>
                    <span>Cartão</span>
                  </li>
                  <li nz-menu-item (click)="openCreator('chart', item.tabName)">
                    <span nz-icon nzType="line-chart" class="dash-menu__icon dash-menu__icon--warn"></span>
                    <span>Gráfico</span>
                  </li>
                  <li nz-menu-item (click)="openCreator('table', item.tabName)">
                    <span nz-icon nzType="table" class="dash-menu__icon dash-menu__icon--success"></span>
                    <span>Tabela</span>
                  </li>
                </ul>
              </nz-dropdown-menu>
            </div>

            <nz-divider class="dash__divider"></nz-divider>

            <!-- Modo avançado: JSON da aba -->
            <div class="dash__advanced" *ngIf="showJSON(item.tabName)">
              <textarea nz-input id="area-expression" autocomplete="off"
                placeholder="Expressão" aria-label="Expressão"
                class="dash__advanced-textarea"
                [formControl]="state(item.tabName).jsonControl"></textarea>
            </div>

            <!-- Grade de gadgets -->
            <div class="dash__grid" *ngIf="!showJSON(item.tabName)" [gridsterAutoResize]="item.options">
              <gridster [options]="item.options"
                class="dash__gridster"
                [class.dash__gridster--edit]="editMode(item.tabName)">
                <ng-container *ngFor="let col of item.gadGets">
                  <gridster-item [item]="col.gridsterItem">
                    <mini-card *ngIf="col.type == 'minicard'" [(item)]="col.minicard"
                      [showConfiguration]="editMode(item.tabName)" [name]="col.name"
                      (deleting)="deletingGadGet($event)"
                      [events]="state(item.tabName).filterApplied$"
                      [dashboard]="item"></mini-card>
                    <chart-card *ngIf="col.type == 'chart'" [(item)]="col.chart"
                      [showConfiguration]="editMode(item.tabName)" [name]="col.name"
                      (deleting)="deletingGadGet($event)"
                      [events]="state(item.tabName).filterApplied$"
                      [dashboard]="item"></chart-card>
                    <table-card *ngIf="col.type == 'table'" [(item)]="col.table"
                      [showConfiguration]="editMode(item.tabName)" [name]="col.name"
                      (deleting)="deletingGadGet($event)"
                      [events]="state(item.tabName).filterApplied$"
                      [dashboard]="item"></table-card>
                  </gridster-item>
                </ng-container>
              </gridster>
            </div>
          </ng-template>

        </div>
      </nz-tab>
    </nz-tabs>
  </div>
</div>
